import React from "react";
import { Flex, Table, TableRow, TableCell, Text, Pagination } from '@aws-amplify/ui-react';

export default function TableComponent({ error, value, objects, handlerClickOnObject, currentPage, totalPages, handleNextPage, handlePreviousPage, nameObject }) {

    return (
        <Flex direction="column">
            {error && <Text color="red">{error}</Text>}
            <Table variation="striped" highlightOnHover={true} className="my-custom-table">
                <TableRow>
                    <TableCell as="th">{value}</TableCell>
                </TableRow>
                {objects.map((obj, index) => (
                    <TableRow key={index}>
                        <TableCell
                            onClick={() => handlerClickOnObject(obj.id)}
                        >{obj[nameObject]}</TableCell>
                    </TableRow>
                ))}
            </Table>
            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onNext={handleNextPage}
                onPrevious={handlePreviousPage}
                className='custom-pagination'
            />
        </Flex>
    );
}